import { Injectable } from '@angular/core';

import { GameBase } from './game-base';
import { ClassicGameFlow } from './game-flows/classic-game-flow';
import { OpenGameFlow } from './game-flows/open-game-flow';
import { ThreeHeadedDragonFlow } from './game-flows/three-headed-dragon-flow';
import { BaccaratGame } from './main-games/baccaraat/baccarat-game';
import { DragonTigerGame } from './main-games/dragon-tiger/dragon-tiger-game';
import { ThreeHeadedDragonGame } from './main-games/three-headed-dragon/three-headed-dragon-game';
import { GameType } from '../models/communication/app-enums.model';

class Baccarat extends BaccaratGame {
    override gameFlow: ClassicGameFlow = new ClassicGameFlow(this);
}

class OpenBaccarat extends BaccaratGame {
    override gameFlow: OpenGameFlow = new OpenGameFlow(this);
}

class DragonTiger extends DragonTigerGame {
    override gameFlow: ClassicGameFlow = new ClassicGameFlow(this);
}

class OpenDragonTiger extends DragonTigerGame {
    override gameFlow: OpenGameFlow = new OpenGameFlow(this);
}

class ThreeHeadedDragon extends ThreeHeadedDragonGame {
    override gameFlow: ThreeHeadedDragonFlow = new ThreeHeadedDragonFlow(this);
}

@Injectable({
    providedIn: 'root'
})

/**
 * Responsible for defining all the different game combinations.
 * It exposes a single method that returns a `GameBase` subclass instance
 * based on a provided `GameType`.
 */
export class GameFactory {
    create(gameType: GameType): GameBase {
        switch (gameType) {
            case GameType.Baccarat:
                return new Baccarat();
            case GameType.OpenBaccarat:
                return new OpenBaccarat();
            case GameType.DragonTiger:
                return new DragonTiger();
            case GameType.OpenDragonTiger:
                return new OpenDragonTiger();
            case GameType.ThreeHeadedDragon:
                return new ThreeHeadedDragon();
            default:
                throw new Error('Invalid game type!');
        }
    }
}
